import { transformSelectedSpecsToString } from '../../../structures/_buy-box/SelectedSpecs';
import { formatNumber } from '../helpers/number-formatter';

/**
 * Transforms a product object into a structured format.
 * @param {Object} product - The product object to transform.
 * @returns {Object} A structured representation of the product with default values.
 */
export default product => {
    return !!product
        ? {
              item_id: product?.sku || 'SKU',
              item_name: product?.name || 'NAME',
              price: formatNumber(product?.price) || 0,
              affiliation: location.hostname || '',
              discount: formatNumber(product?.discountedPrice || 0),
              quantity: product?.amount || 1,
              item_brand: product?.brand || '',
              item_variant: transformSelectedSpecsToString(product?.selectedSpecs) || '',
              // TODO currently not available in product data set
              // item_category: product.category || 'DefaultCategory',
              // item_category2: product.category2 || 'DefaultSubCategory',
          }
        : {};
};
